import { CustomizationV4ApiClient } from '@fourthwall/services/dist/CustomizationV4ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCustomizationV4Query = createQueryHook(CustomizationV4ApiClient.getCustomization, {
  queryKey: ['customizationV4'],
})
